var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"fixed_excel_download",attrs:{"type":"button"},on:{"click":_vm.windowPopupOpen}},[_c('span',{staticClass:"icon_excel"},[_vm._v("X")]),_vm._v(_vm._s(_vm.$t('EXCEL_DOWNLOAD_TITLE'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }